// extracted by mini-css-extract-plugin
export default {"footer":"+aXn5RkNsMTz4A1b0195mg==","footerCheckbox":"i4gT9CBk4k7u1Jgm5H8lpA=="};